import Drawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";
import palette from "assets/theme/base/palette";

const SIDEBAR_WIDTH = 250;
const FLOAT_MARGIN = 16;

export default styled(Drawer)(({ theme, ownerState }) => {
  const { transitions, breakpoints, functions } = theme;
  const { miniSidenav } = ownerState;
  const { pxToRem } = functions;

  const gradient = `linear-gradient(195deg, ${palette.brand[400]}, ${palette.brand[900]})`;

  const floatingCard = {
    background: gradient,
    border: "none",
    borderRadius: "16px",
    margin: `${FLOAT_MARGIN}px`,
    height: `calc(100vh - ${FLOAT_MARGIN * 2}px)`,
    boxShadow: "0 8px 32px rgba(0,0,0,0.28)",
    overflowX: "hidden",
    overflowY: "auto",
  };

  const drawerOpenStyles = () => ({
    ...floatingCard,
    width: SIDEBAR_WIDTH,
    transform: "translateX(0)",
    transition: transitions.create(["width", "transform"], {
      easing: transitions.easing.sharp,
      duration: transitions.duration.enteringScreen,
    }),
  });

  const drawerCloseStyles = () => ({
    ...floatingCard,
    width: pxToRem(88),
    transform: "translateX(0)",
    transition: transitions.create(["width", "transform"], {
      easing: transitions.easing.sharp,
      duration: transitions.duration.shorter,
    }),
  });

  return {
    "& .MuiDrawer-paper": {
      ...(miniSidenav ? drawerCloseStyles() : drawerOpenStyles()),

      // Mobile: slide in/out without floating margin
      [breakpoints.down("xl")]: {
        margin: 0,
        borderRadius: 0,
        height: "100vh",
        width: SIDEBAR_WIDTH,
        transform: miniSidenav ? `translateX(${pxToRem(-SIDEBAR_WIDTH)})` : "translateX(0)",
        transition: transitions.create("transform", {
          easing: transitions.easing.sharp,
          duration: transitions.duration.shorter,
        }),
      },
    },
  };
});
